<template>
    <div class="m-chain-info">
        <div class="item flex-left">
            <i class="iconfont iconBTY"></i>
            <div class="detail">
                <p class="title">BTY {{ $t("home.nPrice") }}</p>
                <p class="value">$ {{ btyInfo.usd }}</p>
            </div>
        </div>
        <div class="item flex-left">
            <i class="iconfont icondangqianzongliang"></i>
            <div class="detail">
                <p class="flex-between">
                    <span class="title">{{ $t("home.nNum") }}</span>
                    <span class="title">{{ $t("home.nMValue") }}</span>
                </p>
                <p class="flex-between">
                    <span class="value"
                        >{{ parseInt(btyInfo.totalSum) | filterNum }} BTY</span
                    >
                    <span class="value"
                        >{{
                            parseInt(btyInfo.totalSum * btyInfo.usd) | filterNum
                        }}
                        USD</span
                    >
                </p>
            </div>
        </div>
        <div class="item flex-left">
            <i class="iconfont iconpingjunchukuai"></i>
            <div class="detail">
                <p class="flex-between">
                    <span class="title">{{ $t("home.avgspeed") }}</span>
                    <span class="title">{{ $t("home.perTxns") }}</span>
                </p>
                <p class="flex-between">
                    <span class="value"
                        >{{ btyInfo.perTime.toFixed(2) }} s</span
                    >
                    <span class="value">{{
                        btyInfo.perTxCount.toFixed(2)
                    }}</span>
                </p>
            </div>
        </div>
        <div class="item flex-left">
            <i class="iconfont iconjiaoyibishu"></i>
            <div class="detail">
                <p class="title">{{ $t("home.txCount") }}</p>
                <p class="value">
                    {{ parseInt(btyInfo.txCount) | filterNum }}
                    {{ $t("home.bi") }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import chainBase from "@/mixins/Home/chainInfo.js";
export default {
    mixins: [chainBase],
};
</script>

<style lang="scss" scoped>
.m-chain-info {
    padding-top: 10px;
    .item {
        margin-bottom: 10px;
        padding: 12px 20px;
        height: 61px;
        background: $white;
        .iconfont {
            margin-right: 20px;
            color: $blue;
            font-size: 35px;
        }
        .detail {
            width: 100%;
            p {
                font-family: PingFangSC;
                line-height: 20px;
            }
            .value {
                color: $black;
            }
            .title {
                color: $font_grey;
            }
        }
    }
}
</style>
